import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { useCallback } from 'react';

import { SVGIcon } from 'components/SVGIcon';

interface AppItemI {
  iconId: string;
  route: string;
  title: string;
  onClose: () => void;
  isCurrentApp?: boolean;
}

export const AppItem: FC<AppItemI> = ({ title, iconId, route, isCurrentApp, onClose }) => {
  const handleClick = useCallback(() => {
    if (!isCurrentApp) {
      window.open(route);
      onClose();
    }
  }, [route, isCurrentApp, onClose]);

  return (
    <Box
      onClick={handleClick}
      sx={{
        padding: '10px 5px',
        border: isCurrentApp ? '1px solid rgba(66, 113, 235, 0.50)' : '',
        borderRadius: '8px',
        cursor: isCurrentApp ? 'default' : 'pointer',
        ':hover': {
          bgcolor: 'rgba(66, 113, 235, 0.08)',
        },
        width: 'auto',
        height: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '9px',
        }}
      >
        <SVGIcon id={iconId} />
        <Typography variant="body2">{title}</Typography>
      </Box>
    </Box>
  );
};
